import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { joinWithCommasAndLastAnd } from '../../../../common/utility/strings'
import { AboutMeProps } from '../../TrainerBio.d'
import styles from './AboutMe.module.scss'

const AboutMe = ({
  text = '',
  trainerAttributes = [],
  isMobile,
  ...props
}: AboutMeProps) => {
  const hasTrainerAttributes = !!trainerAttributes.length

  return (
    <section className={styles.wrapper} {...props}>
      <Heading type={isMobile ? 'h4' : 'h5'} className={styles.heading}>
        About Me
      </Heading>
      {text && (
        <Paragraph size={isMobile ? 'small' : 'default'} weight="book">
          {text}
        </Paragraph>
      )}
      {hasTrainerAttributes && (
        <div className={styles.trainerAttributesBox}>
          <Paragraph size="small" weight="book">
            Campers describe my workouts as...
          </Paragraph>
          <Heading type="h5" className={styles.attributesText}>
            {`“${joinWithCommasAndLastAnd(trainerAttributes)}!”`}
          </Heading>
        </div>
      )}
    </section>
  )
}

export default AboutMe
